<div
  class="home-content-wrap"
  [class.laptop-place-holder-layout]="isLaptopLayout"
  *ngIf="pageData">

  <ng-container *ngIf="isLaptopLayout; else regularHomeLayout">
    <div class="right-column-conainer">
      <ng-container *ngIf="laptopRightWidgetGrid && laptopRightWidgetGrid.length">
        <ng-container *ngFor="let widget of laptopRightWidgetGrid; let i = index">
          <ng-template
            [ngTemplateOutlet]="widgetGridTemplate"
            [ngTemplateOutletContext]="getGridOrderSettings(widget, 3, i)">
          </ng-template>
        </ng-container>
      </ng-container>
    </div>

    <div class="left-and-center-container laptop-left-column-container">
      <ng-container *ngIf="laptopLeftWidgetGrid && laptopLeftWidgetGrid.length">
        <ng-container *ngFor="let widget of laptopLeftWidgetGrid; let i = index">
          <ng-template
            [ngTemplateOutlet]="widgetGridTemplate"
            [ngTemplateOutletContext]="getGridOrderSettings(widget, 2, i)">
          </ng-template>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>

  <ng-template #regularHomeLayout>
    <ng-container *ngIf="mobileHeaderWidgets && mobileHeaderWidgets.length">
      <app-grid-card *ngFor="let widget of mobileHeaderWidgets" class="d-not-phone-tablet-none">
        <app-widget-single-article [widgetData]="widget.data"/>
      </app-grid-card>
    </ng-container>
  
    <div class="right-column-conainer">
      <ng-container *ngIf="pageData.rightWidgetGrid && pageData.rightWidgetGrid.length">
        <ng-container *ngFor="let widget of pageData.rightWidgetGrid; let i = index">
          <ng-template [ngTemplateOutlet]="widgetGridTemplate" [ngTemplateOutletContext]="getGridOrderSettings(widget, 3, i)"></ng-template>
        </ng-container>
      </ng-container>
    </div>
  
  
    <div class="left-and-center-container">
      <div class="row mobile-cards-row d-not-phone-none">
        <div class="col" *ngIf="mobileTrigerWigetsState.messagesMobileBlockData.exists">
          <app-mobile-modal-trigger [isLoading]="mobileTrigerWigetsState.messagesMobileBlockData.loading" [count]="mobileTrigerWigetsState.messagesMobileBlockData.count" 
            [label]="mobileTrigerWigetsState.messagesMobileBlockData.title" (click)="toggleMessages(!!mobileTrigerWigetsState.messagesMobileBlockData.count)" />
        </div>
        <div class="col" *ngIf="mobileTrigerWigetsState.assignmentMobileBlockData.exists">
          <app-mobile-modal-trigger [isLoading]="mobileTrigerWigetsState.assignmentMobileBlockData.loading" [count]="mobileTrigerWigetsState.assignmentMobileBlockData.count" 
            [label]="mobileTrigerWigetsState.assignmentMobileBlockData.title" (click)="toggleAssignments(!!mobileTrigerWigetsState.assignmentMobileBlockData.count)" />
        </div>
        <div class="col" *ngIf="mobileTrigerWigetsState.requestsMobileBlockData.exists">
          <app-mobile-modal-trigger [isLoading]="mobileTrigerWigetsState.requestsMobileBlockData.loading" [count]="mobileTrigerWigetsState.requestsMobileBlockData.count" 
            [label]="mobileTrigerWigetsState.requestsMobileBlockData.title" (click)="toggleRequests(!!mobileTrigerWigetsState.requestsMobileBlockData.count)" />
        </div>
      </div>
  
      <ng-container *ngIf="pageData.centralWidgetGrid && pageData.centralWidgetGrid.length">
        <ng-container *ngFor="let widget of pageData.centralWidgetGrid; let i = index">
          <ng-template [ngTemplateOutlet]="widgetGridTemplate" [ngTemplateOutletContext]="getGridOrderSettings(widget, 1, i)"></ng-template>
        </ng-container>
      </ng-container>
  
      <div class="break"></div>
  
      <ng-container *ngIf="pageData.leftWidgetGrid && pageData.leftWidgetGrid.length">
        <ng-container *ngFor="let widget of pageData.leftWidgetGrid; let i = index">
          <ng-template [ngTemplateOutlet]="widgetGridTemplate" [ngTemplateOutletContext]="getGridOrderSettings(widget, 2, i)"></ng-template>
        </ng-container>
      </ng-container>
    </div>
  </ng-template>

  <input type="hidden" id="currentNodeId" [value]="pageData.pageId" />
</div>
  
  
<div class="home-content-wrap skeleton" *ngIf="!pageData">
  <div class="right-column-conainer">
      <app-grid-card>
          <app-skeleton class="calendar-sceleton"></app-skeleton>
      </app-grid-card>
  </div>


  <div class="left-and-center-container">
    <div class="row mobile-cards-row d-not-phone-none">
      <app-grid-card class="col
      ">
          <app-skeleton [height]="100"></app-skeleton>
      </app-grid-card>
      <app-grid-card class="col">
          <app-skeleton [height]="100"></app-skeleton>
      </app-grid-card>
    </div>

    <app-grid-card class="column-1">
      <app-skeleton [height]="300"></app-skeleton>
    </app-grid-card>
    <app-grid-card class="column-1">
      <app-skeleton [height]="200"></app-skeleton>
    </app-grid-card>
    <app-grid-card class="column-1">
      <app-skeleton [height]="150"></app-skeleton>
    </app-grid-card>
    <app-grid-card class="column-1">
      <app-skeleton [height]="200"></app-skeleton>
    </app-grid-card>
    <app-grid-card class="column-1">
      <app-skeleton [height]="300"></app-skeleton>
    </app-grid-card>
    
    <div class="break"></div>

    <app-grid-card class="column-2" >
      <app-skeleton [height]="100"></app-skeleton>
    </app-grid-card>
    <app-grid-card class="column-2">
      <app-skeleton [height]="300"></app-skeleton>
    </app-grid-card>
    <app-grid-card class="column-2">
      <app-skeleton [height]="150"></app-skeleton>
    </app-grid-card>
    <app-grid-card class="column-2">
      <app-skeleton [height]="200"></app-skeleton>
    </app-grid-card>
    <app-grid-card class="column-2">
      <app-skeleton [height]="200"></app-skeleton>
    </app-grid-card>
  </div>
</div>
  
  

<ng-template #widgetGridTemplate let-widget="widget" let-column="column" let-orderlaptop="orderlaptop">
  <app-grid-card 
      *ngIf="widget.type == PortalWidgetType.WidgetEvents" 
      class="column-{{column}} order-laptop-{{orderlaptop}}">
      <app-widget-close-events-carousel [widgetData]="widget.data" (widgetLoaded)="widgetLoaded()"/>
  </app-grid-card>

  <app-grid-card 
      *ngIf="widget.type == PortalWidgetType.WidgetArticlesAndNews" 
      class="column-{{column}} order-laptop-{{orderlaptop}}">
      <app-widget-news-carousel [widgetData]="widget.data" (widgetLoaded)="widgetLoaded()"/>
  </app-grid-card>

  <app-grid-card
      *ngIf="widget.type == PortalWidgetType.WidgetAssignments" 
      class="column-{{column}} order-laptop-{{orderlaptop}}"
      [mobileModal]="true"
      [open]="openedAssignments"
      [modalTitle]="widget.data.title"
      (closeModal)="toggleAssignments(false)">
      <app-widget-assignments [widgetData]="widget.data" (widgetLoaded)="setAssignmentData($event)"></app-widget-assignments>
  </app-grid-card>

  <app-grid-card 
      *ngIf="widget.type == PortalWidgetType.WidgetMessages" 
      class="column-{{column}} order-laptop-{{orderlaptop}}" 
      [mobileModal]="true" 
      [open]="openedMessages"
      [modalTitle]="widget.data.title" 
      (closeModal)="toggleMessages(false)">
      <div header-link class="mobile-modal-header-link d-not-phone-none grid-card-header-link" *ngIf="widget.data.allLinkUrl">
          <a href="{{widget.data.allLinkUrl}}" target="{{widget.data.allLinkTarget}}" class="more-link">{{widget.data.allLinkText}}</a>
      </div>
      <div class="card-header-mini mb-0 d-phone-none messages-card-header">
          <h3 class="card-title">
              {{widget.data.title}}
              <ng-container *ngIf="mobileTrigerWigetsState.messagesMobileBlockData.exists">({{mobileTrigerWigetsState.messagesMobileBlockData.count}})</ng-container>
              <app-skeleton *ngIf="!mobileTrigerWigetsState.messagesMobileBlockData.exists" class="skeleton" [symbolsCount]="2" [type]="'text'"></app-skeleton>
          </h3>
          <a *ngIf="widget.data.allLinkUrl" href="{{widget.data.allLinkUrl}}" target="{{widget.data.allLinkTarget}}" class="more-link">{{widget.data.allLinkText}}</a>
      </div>
  
      <app-widget-messages [widgetData]="widget.data" (widgetLoaded)="setMessagesData($event)" />
  </app-grid-card>

  <app-grid-card
      *ngIf="widget.type == PortalWidgetType.WidgetRequestsAndProcesses" 
      class="column-{{column}} order-laptop-{{orderlaptop}}"
      [mobileModal]="true"
      [open]="openedRequests"
      [modalTitle]="widget.data.title"
      (closeModal)="toggleRequests(false)"
  >
  <div header-link class="mobile-modal-header-link d-not-phone-none grid-card-header-link" *ngIf="widget.data.allLinkUrl">
       <a href="{{widget.data.allLinkUrl}}" target="{{widget.data.allLinkTarget}}" class="more-link">{{widget.data.allLinkText}}</a>
  </div>
      <app-widget-requests [widgetData]="widget.data" (widgetLoaded)="setRequestsData($event)" />
  </app-grid-card>

  <app-grid-card 
      *ngIf="widget.type == PortalWidgetType.WidgetGrades"
      class="column-{{column}} order-laptop-{{orderlaptop}}">
      <app-widget-recently-received-grades [widgetData]="widget.data" />
  </app-grid-card>

  <app-grid-card 
      *ngIf="widget.type == PortalWidgetType.WidgetAccountState"
      class="column-{{column}} order-laptop-{{orderlaptop}}">
      <app-widget-account-state [widgetData]="widget.data"/>
  </app-grid-card>

  <app-grid-card 
      *ngIf="widget.type == PortalWidgetType.WidgetSingleArticle"
      class="column-{{column}} order-laptop-{{orderlaptop}} d-phone-tablet-none">
      <app-widget-single-article [widgetData]="widget.data"/>
  </app-grid-card>
  
  <app-grid-card 
      *ngIf="widget.type == PortalWidgetType.WidgetStaffCalendar"
      class="column-{{column}} order-laptop-{{orderlaptop}}">
      <app-widget-staff-calendar [widgetData]="widget.data"/>
  </app-grid-card>

  <app-grid-card
      *ngIf="widget.type == PortalWidgetType.WidgetBookmarks"
      class="column-{{column}} order-laptop-{{orderlaptop}}">
      <app-widget-bookmarks [widgetData]="widget.data"/>
  </app-grid-card>   

  <app-widget-student-calendar 
      *ngIf="widget.type == PortalWidgetType.WidgetStudentCalendarExamsAndTasks" 
      class="column-{{column}} order-laptop-{{orderlaptop}}"
      [widgetData]="widget.data">
  </app-widget-student-calendar>
</ng-template>